// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"LoaderElementAbsolute_loaderOverlay__aRaEO","loader":"LoaderElementAbsolute_loader__zZM87","spin":"LoaderElementAbsolute_spin__XQ4HZ"};